import type { MinimalPoolRepository } from "@/domains/minimal-pool/minimal-pool-repository"
import { LcAddress } from "@/domains/core"

import type { IGaugeConnectorStrategy, IRevenueSource } from "../interfaces"
import { REVENUE_SOURCE_TYPE } from "../interfaces"

export class UniswapV2GaugeConnectorStrategy implements IGaugeConnectorStrategy {
  readonly revenueSourceType = REVENUE_SOURCE_TYPE.MINIMAL_POOL

  constructor(private readonly minimalPoolRepository: MinimalPoolRepository) {}

  findRevenueSourceByGauge(gauge: LcAddress): IRevenueSource | undefined {
    const pool = this.minimalPoolRepository.findByGauge(gauge)

    if (!pool) {
      return undefined
    }

    // Return the pool directly - MinimalPoolStore implements IRevenueSource
    // This maintains MobX reactivity since the gauge will observe the actual store instance
    return pool
  }
}
